import React, { useState, lazy, memo, Component } from 'react';
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from 'lucide-react';
const BonusCarousel = memo(() => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const bonuses = [{
    title: 'Planificador Semanal Express',
    description: 'Plantilla imprimible para organizar tus comidas, compras y preparaciones de la semana en solo 10 minutos.',
    value: '$27 USD',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tTBysf5DnKWQBY6JHw9nbK/Bono_1_-_Planificador_semanal.jpg'
  }, {
    title: 'Guía de Salsas y Aderezos Latinos',
    description: '15 recetas de salsas y acompañamientos para elevar tus cenas y darles un toque especial.',
    value: '$19 USD',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/btzWphdbCf5LGUBQqEAe6q/Bono_2_-_Guia_de_aderezos.jpg'
  }, {
    title: 'Reto 7 Días: Cocina Organizada, Vida Organizada',
    description: 'Guía paso a paso para implementar el sistema y transformar tu rutina en solo una semana.',
    value: '$37 USD',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eMXr3uhhkgmGpNUSwfG7Mu/Bono_3_-_Reto_7_dias_menos_estres.jpg'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === bonuses.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? bonuses.length - 1 : prevIndex - 1);
  };
  const currentBonus = bonuses[currentIndex];
  return <div className="relative bg-amber-50 p-6 rounded-lg mb-4" data-id="element-25">
      <div className="mb-4" data-id="element-26">
        <div className="mobile-img-fix h-48 flex items-center justify-center mb-4" data-id="element-27">
          <img src={currentBonus.image} alt={currentBonus.title} className="max-h-full" width="200" height="200" loading="lazy" decoding="async" onError={e => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = `https://via.placeholder.com/200x200/f5f5f5/a97142?text=${encodeURIComponent(currentBonus.title)}`;
        }} data-id="element-28" />
        </div>
        <h4 className="text-xl font-bold mb-2 text-gray-800" data-id="element-29">
          {currentBonus.title}
        </h4>
        <p className="text-gray-600 mb-4" data-id="element-30">{currentBonus.description}</p>
        <p className="font-bold text-custom-brown" data-id="element-31">{currentBonus.value}</p>
      </div>
      <div className="flex justify-between" data-id="element-32">
        <button onClick={prevSlide} className="bg-custom-brown bg-opacity-20 p-2 rounded-full text-custom-brown hover:bg-opacity-30" aria-label="Anterior bono" data-id="element-33">
          <ChevronLeftIcon size={20} data-id="element-34" />
        </button>
        <div className="flex space-x-1" data-id="element-35">
          {bonuses.map((_, index) => <div key={index} className={`w-2 h-2 rounded-full ${index === currentIndex ? 'bg-custom-brown' : 'bg-gray-300'}`} aria-hidden="true" data-id="element-36" />)}
        </div>
        <button onClick={nextSlide} className="bg-custom-brown bg-opacity-20 p-2 rounded-full text-custom-brown hover:bg-opacity-30" aria-label="Siguiente bono" data-id="element-37">
          <ChevronRightIcon size={20} data-id="element-38" />
        </button>
      </div>
    </div>;
});
export default BonusCarousel;